import { FirestoreDataConverter, Timestamp } from "firebase/firestore"
import { ObservationDocument } from "../index"
import dayjs from "dayjs"

export default {
    toFirestore: (observation: ObservationDocument) => ({
        ...observation,
        timestamp: Timestamp.fromDate(observation.timestamp.toDate()),
    }),
    fromFirestore: (snapshot, options) => {
        const observation = snapshot.data(options)
        return {
            id: snapshot.id,
            timestamp: dayjs(observation.timestamp.toDate()),
            type: observation.type,
            totalCount: observation.totalCount,
            items: observation.items,
            status: observation.status,
            message: observation.message,
            chunkSize: observation.chunkSize,
            files: observation.files
        }
    },
} as FirestoreDataConverter<ObservationDocument>
